import React from "react";
import { styled } from "@mui/system";
import MUIMenuItem from "@mui/material/MenuItem";
import { MenuItemProps as MenuItemPropsMUI } from "@mui/material/MenuItem";

export type MenuItemProps = {
  group?: boolean;
  component?: React.ElementType;
} & MenuItemPropsMUI;

export const MenuItem: (props: MenuItemProps) => JSX.Element = styled(
  React.forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => (
    <MUIMenuItem ref={ref} {...props} />
  )),
  {
    name: "MenuItem",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "group",
    overridesResolver: (props, styles) => []
  }
)<{ group?: boolean }>(({ theme, group }) => ({
  paddingTop: "10px",
  paddingBottom: "10px",
  "&.MuiMenuItem-root.MuiMenuItem-gutters.MuiButtonBase-root": {
    paddingLeft: group ? "40px" : "16px"
  },
  "&.MuiMenuItem-root.MuiButtonBase-root": {
    "&:hover": {
      background: theme.palette.primary.surfaceDefault,
      border: "1px solid #0090D1"
    }
  }
}));
